import type { FC, ReactNode } from 'react';

import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from 'src/hooks/use-auth';
import { paths } from 'src/routes/paths';

interface GuestGuardProps {
  children: ReactNode;
}

export const GuestGuard: FC<GuestGuardProps> = props => {
  const { children } = props;
  const { isAuthenticated } = useAuth();
  const router = useNavigate();
  const [checked, setChecked] = useState<boolean>(false);
  const check = useCallback(() => {
    if (isAuthenticated) {
      void router(paths.dashboard.root, { replace: true });
    } else {
      setChecked(true);
    }
  }, [isAuthenticated, router]);

  // Only check on mount, this allows us to redirect the user manually when auth state changes
  useEffect(() => {
    check();
  }, [check]);

  if (!checked) {
    return null;
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // not authenticated / authorized.

  return <>{children}</>;
};
